import React, { useState, useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useForm } from 'react-hook-form'
import { Link, useHistory } from 'react-router-dom'
import { BsFillCameraVideoFill, BsImages } from 'react-icons/bs'
import { MdAddAPhoto, MdLocalOffer } from 'react-icons/md'
import { GiBoomerang, GiPerspectiveDiceThree } from 'react-icons/gi'
import Layout from '../../../components/layouts/Layout'
import { eventSharingReset, featureEvent } from './slice/createEventSlice'
import NewFormWizard from '../../../components/formWizard/NewFormWizard'
import { HiOutlineShare } from 'react-icons/hi'
import http from '../../../config/BaseUrl'
import { LoadingSpinner } from '../../../components/Loader/Loader'
import LocalStorage from '../../../hook/LocalStorage';
import { getPackagePermissions } from '../packageAccess';

const EventFeatures = () => {

    const history = useHistory();
    const dispatch = useDispatch();

    const { user } = LocalStorage()
    // const eventId = history.location.state
    const { feature, eventId } = useSelector(state => state.createEvent);
    const membershipPackageId = user?.membership?.package_id ?? user?.membership?.our_package?.id
    const [packageTypes, setPackageTypes] = useState(null)
    const [packageAccessStatus, setPackageAccessStatus] = useState("loading")
    const [packageRequestKey, setPackageRequestKey] = useState(0)
    const [loading, setLoading] = useState(false)
    const [draftLoading, setDraftLoading] = useState(false)
    const [submitError, setSubmitError] = useState("")
    const { register, handleSubmit } = useForm({
        defaultValues: {
            still_photo: feature.still_photo,
            video: feature.video,
            boomerang: feature.boomerang,
            sharing: feature.sharing,
            gallery: feature.gallery,
            offer: feature.offer,
            three_in_one: feature.three_in_one,
            data_capture: feature.data_capture,
        }
    });

    useEffect(() => {
        let mounted = true

        const loadPackagePermissions = async () => {
            setPackageAccessStatus("loading")
            setPackageTypes(null)

            try {
                const res = await http.get('/package-type')
                const permissions = getPackagePermissions(
                    res?.data?.packageType,
                    membershipPackageId
                )

                if (mounted) {
                    setPackageTypes(permissions)
                    setPackageAccessStatus(
                        permissions.data_capture === null ? "partial" : "ready"
                    )
                }
            } catch (error) {
                if (mounted) {
                    setPackageTypes(null)
                    setPackageAccessStatus("error")
                }
            }
        }

        loadPackagePermissions()

        return () => {
            mounted = false
        }
    }, [membershipPackageId, packageRequestKey])

    const hasDataCaptureAccess = (
        (packageAccessStatus === "ready" || packageAccessStatus === "partial") &&
        packageTypes?.data_capture === true
    )

    const getDataCaptureAccessMessage = () => {
        if (packageAccessStatus === "loading") return "Checking package access..."
        if (packageAccessStatus === "error") return "Unable to verify package access"
        if (packageTypes?.data_capture === null || packageTypes?.data_capture === undefined) return "Package access unavailable"
        return packageTypes.data_capture ? "" : "Upgrade your package"
    }


    const handelFeature = async (data) => {

        dispatch(featureEvent(data))

        if (data.sharing === false) {
            dispatch(eventSharingReset())
        }
        setLoading(true)
        setSubmitError("")

        try {
            await http.post("event-feature", { ...data, eventId })
            history.push("/event/options", eventId)
        } catch (error) {
            setSubmitError("Unable to save event features. Please try again.")
        } finally {
            setLoading(false)
        }

    }

    const saveAsDraft = () => {
        handleSubmit(async (data) => {
            dispatch(featureEvent(data))

            if (data.sharing === false) {
                dispatch(eventSharingReset())
            }
            setDraftLoading(true)
            setSubmitError("")

            try {
                await http.post("event-feature", { ...data, eventId })
            } catch (error) {
                setSubmitError("Unable to save this draft. Please try again.")
            } finally {
                setDraftLoading(false)
            }
        })()
    }

    return (
        <Layout>
            <NewFormWizard />
            <form onSubmit={handleSubmit(handelFeature)}>
                <section className="mt-5">
                    <div className="row justify-content-center">
                        <div className="col-md-10">
                            <div className="px-4 card" style={{ minHeight: '50vh' }}>
                                <div className="card-body">
                                    <div className="pt-5 select__photo--area">
                                        <div className="flex-wrap d-flex justify-content-center">

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox" checked   {...register("still_photo")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <MdAddAPhoto size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Still Photo</p>
                                                    </div>
                                                </label>
                                            </div>
                                            
                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox"  {...register("three_in_one")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <GiPerspectiveDiceThree size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">3 In 1</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox"  {...register("video")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <BsFillCameraVideoFill size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Video</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox"  {...register("boomerang")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <GiBoomerang size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Boomerang</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox"  {...register("gallery")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <BsImages size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Gallery</p>
                                                    </div>
                                                </label>
                                            </div>

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox"  {...register("sharing")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <HiOutlineShare size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Sharing</p>
                                                    </div>
                                                </label>
                                            </div>

                                            {/* <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input type="checkbox" className="checkbox"  {...register("offer")} />
                                                    <div className="option_inner photo__booth">
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <MdLocalOffer size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Offer</p>
                                                    </div>
                                                </label>
                                            </div> */}

                                            <div className="photo__booth__area_checkbox">
                                                <label className="option_item">
                                                    <input 
                                                        type="checkbox" 
                                                        className="checkbox" 
                                                        disabled={!hasDataCaptureAccess}
                                                        {...register("data_capture")} />
                                                    <div 
                                                        className={`option_inner photo__booth ${hasDataCaptureAccess ? '' : 'disable-item'}`}>
                                                        <div className="tick-mark"></div>
                                                        <div className="icon">
                                                            <GiBoomerang size={25} color={'#fff'} />
                                                        </div>
                                                        <p className="mt-2 mb-0 text-white">Data Capture</p>
                                                    </div>
                                                    {getDataCaptureAccessMessage() ? <div className="option_inner_popup"><p>{getDataCaptureAccessMessage()}</p></div> : null}
                                                </label>
                                            </div>

                                        </div>
                                    </div>
                                </div>
                                <div className="py-5 text-center border-top">
                                    <h4 className="text-primary display-4 event-form-title">Event Features</h4>
                                    <span className="text-secondary">Select the features you want active.</span>
                                </div>
                            </div>
                        </div>
                    </div>


                    <div className="my-5 row justify-content-center">
                        <div className="col-md-10">
                            {packageAccessStatus === "error" ? (
                                <div className="mb-3 alert alert-warning" role="alert">
                                    We could not verify your package access. Package-restricted features are temporarily unavailable.
                                    <button type="button" className="ml-3 btn btn-sm btn-outline-dark" onClick={() => setPackageRequestKey(key => key + 1)}>Retry</button>
                                </div>
                            ) : null}
                            {packageAccessStatus === "partial" ? (
                                <div className="mb-3 alert alert-warning" role="alert">Data Capture could not be matched to your current package. Please contact support.</div>
                            ) : null}
                            {submitError ? <div className="mb-3 alert alert-danger" role="alert">{submitError}</div> : null}
                            <button type="button" onClick={() => history.push({ pathname: '/event/create', state: { eventId } })} className="float-left px-5 btn btn-outline-secondary radius-10">Back</button>

                            {loading ?
                                (<button className="float-right px-5 btn btn-primary radius-10" disabled>
                                    <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                </button>)
                                : <button type="submit" disabled={draftLoading} className="float-right px-5 btn btn-primary radius-10">Next</button>
                            }

                            {
                                draftLoading ?
                                    (<button className="float-right px-3 mr-2 btn btn-secondary radius-10" disabled>
                                        <LoadingSpinner color="text-white" className="spinner-grow-sm" />
                                    </button>)
                                    :
                                    <button type="button" disabled={loading} onClick={saveAsDraft} className="float-right px-3 mr-2 btn btn-secondary radius-10">Save as draft</button>
                            }
                        </div>
                    </div>

                </section>
            </form>
        </Layout>
    )
}

export default EventFeatures
